import { ArrowLeftOutlined } from '@ant-design/icons';
import { Row, Col, Typography, Divider } from 'antd';
import { ProcedureBridgeApi } from 'client/components/schema/procedure-bridge/ProcedureBridgeApi';
const { Text } = Typography;
import { DossierListTable } from 'client/components/schema/procedures/table/DossierListTable';
import { RequestApi } from 'client/components/schema/requests/RequestApi';
import { useApiQuery } from 'client/core/network/hooks/useApiQuery';
import { RequestProcedureInfo } from 'client/routes/front/procedures/single/shared/RequestProcedureInfo';
import { PageMainColumn } from 'client/ui/layout/page/PageMainColumn';
import { tableLoaderSpin } from 'client/ui/loader/tableLoaderSpin';
import { AttachmentInfo } from 'common/dto/RequestDossierDto';
import { IRequest } from 'common/schema/request/Request';
import { RequestLogic } from 'common/schema/RequestLogic';
import React from 'react';
import { Link } from 'react-router-dom';
import { DocumentTitleRow } from './DocumentTitleRow';
import { getRequestDocumentListColumns } from './getRequestDocumentListColumns';

export interface IRequestDocumentMainColumnProps {
  request: IRequest;
  token: string;
  isAdmin?: boolean;
}

export function RequestDocumentMainColumn(
  props: IRequestDocumentMainColumnProps
) {
  const { request, token, isAdmin } = props;

  const document = useApiQuery(ProcedureBridgeApi.getDocumentInfo, {
    skip: request.id == null || token == null,
    data: {
      requestId: request.id!,
      token: token
    }
  });

  const attachments = useApiQuery(ProcedureBridgeApi.getAttachments, {
    skip: request.id == null || token == null,
    data: {
      requestId: request.id!,
      token: token
    }
  });

  const documentInfo = document.response?.data;
  const attachmentsInfo = attachments.response?.data as AttachmentInfo[];
  const isTypeEach = RequestLogic.isDossierTypeEach(request);

  const columns = getRequestDocumentListColumns(request.id, token);

  return (
    <>
      {/* Colonna Principale */}
      <PageMainColumn isAdmin={isAdmin}>
        <Row align="middle">
          <Col flex="1 1 auto">
            <Link
              to={RequestApi.links.documentBacklink(
                isAdmin,
                request.id,
                request.procedureId,
                isTypeEach
              )}
            >
              <span style={{ fontSize: '1.14em', marginBottom: '12px' }}>
                <ArrowLeftOutlined /> Torna al
                {isTypeEach ? ' fascicolo' : ' dettaglio'}
              </span>
            </Link>
          </Col>

          <Col flex="0 0 auto" style={{ textAlign: 'right' }}>
            <Text type="secondary">{request.code}</Text>
          </Col>
        </Row>

        <Row>
          <Col>
            <RequestProcedureInfo request={request} />
          </Col>
        </Row>
        <Divider />
        <DocumentTitleRow
          documentInfo={document.error ? undefined : documentInfo}
          token={token}
          requestId={request.id}
          isAdmin={isAdmin}
        />
        <DossierListTable
          title="Elenco degli allegati"
          loading={tableLoaderSpin(document.loading || attachments.loading)}
          tableLayout="fixed"
          showHeader={false}
          size="small"
          rowKey={record => record.data.id}
          dataSource={attachments.error ? [] : attachmentsInfo}
          columns={columns}
          pagination={false}
          indentSize={30}
        />
      </PageMainColumn>
    </>
  );
}
